import { Pipe, PipeTransform } from '@angular/core';
import { SpaSimpleProductSummaryDTO } from '@api';
import { DateTime } from 'luxon';

@Pipe({
  name: 'timeSlot',
  standalone: true,
})
export class TimeSlotPipe implements PipeTransform {
  timeFormat = 'HH:mm';
  today = DateTime.now().toFormat('yyyy-MM-dd');

  transform(product: SpaSimpleProductSummaryDTO): string {
    if (product.durationType !== 'MINUTES') {
      throw new Error('Only MINUTES duration type is supported');
    }
    const from = DateTime.fromFormat(`${this.today} ${product.openingHoursStart}`, 'yyyy-MM-dd HH:mm:ss');
    const to = from.plus({ minutes: product.duration });

    return from.toFormat(this.timeFormat) + ' - ' + to.toFormat(this.timeFormat);
  }
}
